<app-status-pipeline
  [pageView]="pageView()"
  [steps]="steps"
  [currentStatus]="currentStatus"
></app-status-pipeline>
